import React, {Component} from 'react';
import {NavBar,Checkbox,Toast} from "antd-mobile";
import { cancelUserCode } from "../../../service/memberService";
import {connect} from "react-redux"; 
import "./style.less";
const CheckboxItem = Checkbox.CheckboxItem;

@connect(
    state => ({userInfo: state.userInfo})
)
export default class Cancellation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            protocolVal: false,
        };
    }

    componentDidMount() {

    }
    Submit = () => {
        if(this.state.protocolVal === false){
            Toast.info("请阅读勾选同意后注销");
            return
        }
        Toast.loading("",0);
        let params = {
            token: this.props.userInfo.token,
            source:1,
            data:{phone:this.props.userInfo.phone,}
        };
        cancelUserCode(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.hide();
                this.props.history.push('/cancelUserCode');
            } else {
                Toast.info(res.data.msg);
            }
        })
    };
    protocolChange =(e)=>{
        this.setState({protocolVal:e.target.checked});
    };
    render() {
        return (
            <div className="cancellation">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >账号注销</NavBar>

                <div className="warp">
                    <p className="title">为保证您的账号安全，在您提交的注销申 请生效前，请确认满足以下条件</p>
                    <div className='box'>
                        <p className='tit'>1. 您的账号处于安全状态</p>
                        <p className='info'>账号处于安全状态，无争议订单及被盗用的风险</p>
                    </div>
                    <div className='box'>
                        <p className='tit'>2. 您的账号财产已结清</p>
                        <p className='info'>您的钱包已无资金，本账户下的所有订单无需在有其他操作</p>
                    </div>
                    <div className='tips'>账号一旦注销完成，您之前的相关记录将不存在，请谨慎操作！</div>
                    <div className="protocol">
                        <CheckboxItem  onChange={(e) => this.protocolChange(e)} checked={this.state.protocolVal}>已阅读并满足以上条件 同意注销</CheckboxItem>
                    </div>
                    <button onClick={this.Submit}>下一步</button>
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/Cancellation/index.js